import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';
import { ToothNotation } from './types';

interface ToothNumberingToggleProps {
  value: ToothNotation;
  onChange: (notation: ToothNotation) => void;
}

export function ToothNumberingToggle({ value, onChange }: ToothNumberingToggleProps) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 p-1">
      <button
        type="button"
        onClick={() => onChange('fdi')}
        className={cn(
          'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
          value === 'fdi'
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white',
        )}
      >
        {t('dental.numbering.fdi')}
      </button>
      <button
        type="button"
        onClick={() => onChange('haderup')}
        className={cn(
          'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
          value === 'haderup'
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white',
        )}
      >
        {t('dental.numbering.haderup')}
      </button>
    </div>
  );
}
